var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeat4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3489_6815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8097 2.37688L42.2964 0.126068C41.8737 -0.0837008 41.3713 -0.029161 41.0037 0.270808L26.744 11.1972L32.6562 15.9358L40.2174 10.4299V27.591L23.3181 14.0191L6.4187 0.447013C6.04905 0.151239 5.54871 0.0967 5.12802 0.306469L0.69027 2.52373C0.269573 2.73348 0 3.174 0 3.65647V34.4925C0 34.9748 0.267531 35.4154 0.69027 35.6251L5.20562 37.874C5.62836 38.0837 6.13074 38.0291 6.49834 37.7292L19.5938 26.1985L13.6815 21.4599L7.2846 27.568V10.5558L41.0649 37.7103C41.4346 38.0061 41.9349 38.0606 42.3556 37.8508L47.5 35.2791V3.50754C47.5 3.02506 47.2325 2.58455 46.8097 2.37478V2.37688Z",
    fill: "#5ED3F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3489_6815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.5,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat4);
export default __webpack_public_path__ + "static/media/feat-4.1e0020027cb4bab826584ae4079ae90f.svg";
export { ForwardRef as ReactComponent };